import { getCaseId, getClientId } from "../../../Utils/helper";
import { uploadCaseDocuments } from "../../DocPage/new-tab/utils/upload-documents";
import { uploadCasePhotos } from "../../Photo/NewPhotoPage/utils/upload-photos";

const PHOTO_EXTENSIONS = new Set([
  "avif",
  "bmp",
  "gif",
  "heic",
  "heif",
  "jfif",
  "jpe",
  "jpeg",
  "jpg",
  "png",
  "tif",
  "tiff",
  "webp",
]);

export const getUploadKind = (fileName) => {
  const extension = String(fileName || "")
    .match(/\.([^.]+)$/)?.[1]
    ?.toLowerCase();
  return PHOTO_EXTENSIONS.has(extension) ? "photo" : "document";
};

export const uploadCaseFiles = async (files, { pageId = null, onFileProgress } = {}) => {
  const caseId = getCaseId();
  const clientId = getClientId();
  const targetPageId = pageId === "all" || pageId === "" ? null : pageId;
  const result = { uploaded: 0, failed: 0, documents: 0, photos: 0, caseId, pageId: targetPageId };

  for (const [index, file] of Array.from(files || []).entries()) {
    const kind = getUploadKind(file.name);
    const reportProgress = (_, update) =>
      onFileProgress?.(index, {
        ...update,
        kind,
        destination: targetPageId === null ? "case" : "page",
      });
    const context = { caseId, clientId };
    const uploaded =
      kind === "photo"
        ? await uploadCasePhotos([file], () => ({ page_id: targetPageId }), {
            ...context,
            onFileProgress: reportProgress,
          })
        : await uploadCaseDocuments([file], reportProgress, { ...context, pageId: targetPageId });

    result.uploaded += uploaded.uploaded;
    result.failed += uploaded.failed;
    result[kind === "photo" ? "photos" : "documents"] += uploaded.uploaded;
  }

  return result;
};
